import { render, staticRenderFns } from "./step7.vue?vue&type=template&id=b15f8704&scoped=true"
import script from "./step7.vue?vue&type=script&lang=js"
export * from "./step7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15f8704",
  null
  
)

export default component.exports